module.exports = __webpack_public_path__ + "img/college2.dec0a8d7.png";